module.exports = __webpack_public_path__ + "img/helmi.62a09d24.jpg";